import { Component } from '@angular/core';
import {Inject} from "@angular/core";
import {DOCUMENT} from "@angular/platform-browser";
import { IonicPage, NavController, NavParams, ViewController, ModalController, AlertController, ToastController } from 'ionic-angular';

import { Assessment } from '../../models/assessment';
import { Items } from '../../providers/providers';
import { UserData } from '../../models/user';
import { UserAccount } from '../../models/account';
import { AbstractControl, ValidationErrors, Validators, EmailValidator, FormControl } from '@angular/forms';
import { Client } from '../../models/client';
import { Template } from '../../models/template';
/**
 * Generated class for the EmailPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-email',
  templateUrl: 'email.html',
})
export class EmailPage {
  private dom: Document;
  email: string = "Select Assessment";
  clientId: string;
  clientFirstName: string;
  clientLastName: string;
  clientEmail: string;
  clientEmail2: string;
  parentName1: string;
  parentName2: string;
  assessments: Assessment[];
  assessmentsTag: Assessment[] = [];
  assessmentNameTag = [];
  assessment: Assessment;
  emailSelected: boolean;
  userData: UserData;
  isReadyToSend: boolean;
  userAccountData: UserAccount;
  copyUrlText: string;
  tooltipEvent: 'click' | 'press' = 'click';
  showArrow: boolean = true;
  duration: number = 5000;
  position: string = 'top';
  buttonText: string;
  myControl: FormControl;
  emailTemplates: Template[]
  template: Template;
  replace: string;
  recipient: string = '0';

  selectedAssessments: { short_name: string, extended_name: string } = {
    short_name: 'First Name',
    extended_name: 'Last Name'
  };

  sendEmail: { subject: string, body: string } = {
    subject: '',
    body: ''
  };

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public items: Items,
    public modalCtrl: ModalController, public alertCtrl: AlertController, public toastCtrl: ToastController,@Inject(DOCUMENT) dom: Document) {

    
    this.dom = dom;
    this.buttonText = "SEND";
    this.userData = <UserData>JSON.parse(localStorage.getItem('userData'));
    this.clientId = this.navParams.get('client').clientId;
    this.clientFirstName = this.navParams.get('client').clientFirstName;
    this.clientLastName = this.navParams.get('client').clientLastName;
    this.clientEmail = this.navParams.get('client').clientEmail;
    this.clientEmail2 = this.navParams.get('client').clientEmail2;
    this.parentName1 = this.navParams.get('client').parentName1;
    this.parentName2 = this.navParams.get('client').parentName2;
    this.emailSelected = false;

    if (!this.clientEmail2) {
      this.recipient = '1';
    }
//     this.sendEmail.subject = this.getTitle(this.userData.title_id) + ` ` +this.userData.first_name + ` ` + this.userData.last_name + ' ' + "assessment request";
//     this.sendEmail.body = "Dear " + this.clientFirstName + " " +this.clientLastName +`,
    
// This is an automated email setup by ` +  this.getTitle(this.userData.title_id) + ` ` +this.userData.first_name + ` ` + this.userData.last_name + ` who would like you to fill in a questionnaire to check in with you. Please click the link below and follow the prompts to fill in the assessment. The results will be available to ` + this.getTitle(this.userData.title_id) + ` ` +this.userData.first_name + ` ` + this.userData.last_name + ` once you have submitted the assessment. 
// Thank you.`+ `\n` + `\n` +


// this.getLifeLineText();
this.sendEmail.subject = this.getTitle(this.userData.title_id) + ` ` +this.userData.first_name + ` ` + this.userData.last_name + ' ' + "assessment request";
this.sendEmail.body = "Dear #parentname " +`,

As part of your participation in the ‘Measuring Change in Parenting Programs’ research study at the Child Behaviour Research Clinic, please complete the weekly measures at the link below prior to the next scheduled session with your clinician.`+ `\n` + `\n` +


`This is an automated email setup by ` + this.getTitle(this.userData.title_id) + ` ` +this.userData.first_name + ` ` + this.userData.last_name + `. Please click the link below and follow the prompts. The measures only take a few minutes to do online and data will be kept securely and confidentially. The results will be available to your clinician once you have completed the measures.`+ `\n` + `\n` +
`Thank you.`;

  }

  getAssessmentForId(assessmentId){
    return this.assessments.find(x => x.id == assessmentId);
  }

  ionViewDidLoad() {
    this.items.getAssessmentList().subscribe(res => {
      if (res) {
        this.assessments = res; 
        if(this.navParams.data.batteryAssessments){
          for(let i = 0; i < this.navParams.data.batteryAssessments.length; i++ ){
            var assessmentId = this.navParams.data.batteryAssessments[i];
            var assessment = this.getAssessmentForId(assessmentId);
            this.assessmentSelected(assessment,false);
          }
          this.copyUrl();
        }
        if (this.navParams.data.assessment) {
          var selectedAssessment = this.getAssessmentForId(this.navParams.data.assessment.id);
          this.assessmentSelected(selectedAssessment,true);
        }
      }
    }, err => {
      console.error('ERROR', err);
    });

    //get emailTemplates
    this.items.getEmailTemplates().subscribe(res => {
      if (res) {
        let emailTemplates = res;
        //filter the templtes with blank title
        this.emailTemplates = emailTemplates.filter(function (e) {
          return e.title != "";
      });
      for (let i = 0; i < this.emailTemplates.length; i++) {
        if (this.emailTemplates[i].default == true) {
          this.insertTemplate(this.emailTemplates[i])
        }
      }
      }
    }, err => {
      console.error('ERROR', err);
    });
  }

  insertTemplate(value){
    this.sendEmail.subject = value.subject;
    this.replace = value.body
    const clientFirstName = this.replace.replace(/#clientfirstname/g, this.clientFirstName)
    const title = clientFirstName.replace(/#practitionertitle/g, this.getTitle(this.userData.title_id))
    const firstName = title.replace(/#practitionerfirstname/g, this.userData.first_name)
    const lastName = firstName.replace(/#practitionerlastname/g, this.userData.last_name)
    const profession = lastName.replace(/#profession/g, this.getProfession(this.userData.profession_id))
    const clientLastName = profession.replace(/#clientlastname/g, this.clientLastName)
    this.sendEmail.body = clientLastName
  }

  specifyParent(body, parent1 = false){    
    let bodyParent = body.replace(/#parentname/g, this.parentName1)
    if (!parent1) {
      bodyParent = body.replace(/#parentname/g, this.parentName2)
    }
    return bodyParent
  }

  cancel() {
    this.assessmentsTag.length = 0;
    for(let assessment of this.assessments ){
      assessment.selected = false;
    }
    this.viewCtrl.dismiss();
  }

  assessmentSelected(item,copyUrl:boolean) {
    this.isReadyToSend = true;
    var index = this.assessmentsTag.indexOf(item);
    if (index > -1) {
      this.assessmentsTag.splice(index, 1);
      this.assessmentNameTag.splice(index, 1);
      item.selected = false;
      if (this.assessmentsTag.length == 0) {
        this.isReadyToSend = false;
      }else{
        if(copyUrl){this.copyUrl();}
      }
    } else {
      //little hack to display the tag name
      this.assessmentsTag.push(item);
      this.assessmentNameTag.push(item.short_name);
      item.selected = true;
      if(copyUrl){this.copyUrl();}
    }
  }

  onChange(val) {
    // var tempArray = new Array<Assessment>();
    // tempArray = this.assessmentsTag.slice();
    // for (let i = 0; i < val.length; i++) {
    //   var name = val[i];
    //   var index = this.assessmentsTag.findIndex(x => x.short_name == name);
    //   if (index > -1) {
    //     this.assessmentsTag.splice(index, 1);
    //   }
    // }
    // this.assessmentsTag[0].selected = false;
    // var index = tempArray.findIndex(i => i.short_name === this.assessmentsTag[0].short_name);
    // tempArray.splice(index, 1);
    // this.assessmentsTag = tempArray;
    // if (this.assessmentsTag.length == 0) {
    //   this.isReadyToSend = false;
    // }else{
    //   this.copyUrl();
    // }
  }

  filterAssessments(ev) {
    var val = ev.target.value;
    this.assessments = this.items.getAssessments(val);
    return this.assessments;

  }

  makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}

  administer(val: string) {
    if (val == "SEND") {
      if (this.clientEmail == '') {
        this.presentAlert()
      }
      else {
        let assessmentIds = [];
        for (let assessment of this.assessmentsTag) {
          assessmentIds.push(assessment.id);
        }
        
        let parent_1 = 0;
        let parent_2 = 1;
        let email_1 = this.specifyParent(this.sendEmail.body, true).replace(/[\r\n]+/g, '\n\n');
        let email_2 = this.specifyParent(this.sendEmail.body, false).replace(/[\r\n]+/g, '\n\n');

        if (this.recipient == '2') {
          parent_1 = 1;
          parent_2 = null;

          email_1 = this.specifyParent(this.sendEmail.body, false).replace(/[\r\n]+/g, '\n\n');
        }

        if (this.recipient == '1') {
          parent_1 = 0;
          parent_2 = null;
        }

        
        this.isReadyToSend = false;
        var matching_id = this.makeid(8) + '-' + this.makeid(4) + '-' + this.makeid(4) + '-' + this.makeid(4) + '-' + this.makeid(12)
        this.items.emailAssessments(
          {
            client_id: this.clientId,
            matching_id: matching_id,
            is_parent_2: parent_1,
            assessments: assessmentIds,
            start_date: false,
            repeat_cycle: 0,
            repeat_count: 0,
            email_subject: this.sendEmail.subject,
            email_body: email_1,
            client_email_results: this.emailSelected
          }).subscribe((resp) => {
            if (this.clientEmail2 && parent_2) {
              this.items.emailAssessments(
                {
                  client_id: this.clientId,
                  matching_id: matching_id,
                  is_parent_2: parent_2,
                  assessments: assessmentIds,
                  start_date: false,
                  repeat_cycle: 0,
                  repeat_count: 0,
                  email_subject: this.sendEmail.subject,
                  email_body: email_2,
                  client_email_results: this.emailSelected
                }).subscribe((resp) => {
                  this.viewCtrl.dismiss({form: null, dismiss:'create'});
                }, (err) => {


                });
            } else {
              this.viewCtrl.dismiss({form: null, dismiss:'create'});
            }
          }, (err) => {


          });
      }
    } else {
      this.navCtrl.push('home');
    }
  }

  createAlertText(){
    var assessmentString = this.assessmentNameTag.join();
    
    return assessmentString + ' sent to';
  }

  presentAlert() {
    let alert = this.alertCtrl.create({
      title: 'No Email Provided',
      subTitle: 'There is no email address entered for this client. Please add an email to continue',
      inputs: [
        {
          name: 'email',
          placeholder: 'Email'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Ok',
          handler: data => {
            this.myControl = new FormControl(data.email, this.emailOrEmpty)
            if(this.myControl.valid){
              let client = new Client();
              client.email = data.email
              this.items.editClient(client, this.clientId).subscribe((resp) => {
                if(resp){
                  this.clientEmail = data.email;
                }
                
              }, (err) => {
                console.error('there was an error adding the email')
    
              });
            }
            else{
              this.presentToast('Invalid Email');
              return false;
            }
          }
        }
      ]
    });
    alert.present();
  }

  emailOrEmpty(control: AbstractControl): ValidationErrors | null {
    return control.value === '' ? null : Validators.email(control);
}

  getTitle(val){
    switch(val) { 
      case "2": { 
         return "Dr"; 
      } 
      case "1": {  
         return "Mr"; 
      } 
      case "4": { 
         return "Mrs";    
      } 
      case "3": { 
         return "Prof"; 
      } 
      case "5": { 
        return "Ms"; 
      }
      default: { 
         break;              
      } 
   }
  }

  
  getLifeLineText() {
    if (this.userData.country_id == 13) {
      return `If you are in need urgent assistance please contact Lifeline on 13 11 14.`
    }
}

presentLimitAlert() {        
  let parent_1 = 0;
  let parent_2 = 1;
  let email_1 = this.specifyParent(this.sendEmail.body, true).replace(/[\r\n]+/g, '\n\n');
  let email_2 = this.specifyParent(this.sendEmail.body, false).replace(/[\r\n]+/g, '\n\n');

  if (this.recipient == '2') {
    parent_1 = 1;
    parent_2 = null;

    email_1 = this.specifyParent(this.sendEmail.body, false).replace(/[\r\n]+/g, '\n\n');
  }

  if (this.recipient == '1') {
    parent_1 = 0;
    parent_2 = null;
  }

  let alert = this.alertCtrl.create({
    title: parseInt(this.userAccountData.max_assessments) - parseInt(this.userAccountData.monthly_administered_assessments) + ' tests left on your limit',
    subTitle: 'You are currently on the ' + this.userAccountData.chargebee_plan + ' Plan, which allows you to have ' + this.userAccountData.max_assessments + ' tests. You have administered ' + this.userAccountData.monthly_administered_assessments + ' tests so far. ' + 'Would you like to upgrade to increase your limit?',
    buttons: [
      {
        text: 'Later',
        handler: data => {
          if (parseInt(this.userAccountData.monthly_administered_assessments) < parseInt(this.userAccountData.max_assessments)) {
            let assessmentIds = [];
            for (let assessment of this.assessmentsTag) {
              assessmentIds.push(assessment.id);
            }
            this.isReadyToSend = false;
            var matching_id = this.makeid(8) + '-' + this.makeid(4) + '-' + this.makeid(4) + '-' + this.makeid(4) + '-' + this.makeid(12)
            this.items.emailAssessments(
              {
                client_id: this.clientId,
                matching_id: matching_id,
                is_parent_2: parent_1,
                assessments: assessmentIds,
                start_date: false,
                repeat_cycle: 0,
                repeat_count: 0,
                email_subject: this.sendEmail.subject,
                email_body: email_1,
                client_email_results: this.emailSelected
              }).subscribe((resp) => {
                if (this.clientEmail2) {
                  this.items.emailAssessments(
                    {
                      client_id: this.clientId,
                      matching_id: matching_id,
                      is_parent_2: parent_2,
                      assessments: assessmentIds,
                      start_date: false,
                      repeat_cycle: 0,
                      repeat_count: 0,
                      email_subject: this.sendEmail.subject,
                      email_body: email_2,
                      client_email_results: this.emailSelected
                    }).subscribe((resp) => {
                      let modal = this.modalCtrl.create('AlertPage', { text: this.createAlertText(), clientFirstName: this.clientFirstName, clientLastName: this.clientLastName });
                      modal.present();
                    }, (err) => {
      
      
                    });
                } else {
                  let modal = this.modalCtrl.create('AlertPage', { text: this.createAlertText(), clientFirstName: this.clientFirstName, clientLastName: this.clientLastName });
                  modal.present();
                }
              }, (err) => {


              });
          }
        }
      },
      {
        text: 'Upgrade',
        handler: data => {
          this.navCtrl.push('account');
        }
      }
    ]
  });
  alert.present();
}

  clearUrl(){
    this.copyUrlText = "";
    this.buttonText = "DONE"
  }

  
//https://forum.ionicframework.com/t/just-released-tooltips-module-for-ionic-apps/97065/17 tooltip-color
  copyUrl() {
        let assessmentIds = [];
        for (let assessment of this.assessmentsTag) {
          assessmentIds.push(assessment.id);
        }
        this.items.getAssessmentsURL(
          {
            client_id: this.clientId,
            assessments: assessmentIds,
            client_email_results: this.emailSelected
          }).subscribe((resp) => {
            if(resp){
              this.copyUrlText = resp.schedule.url;
              // this.buttonText = "DONE"
            }
          }, (err) => {
            this.presentToast("There was an error getting the assessment url");
          });
  }

  emailResultToClient(){
    this.copyUrl()
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  getProfession(val){
    switch(val) { 
      case "14": { 
         return "Psychologist"; 
      } 
      case "12": {  
         return "Psychiatrist"; 
      } 
      case "9": { 
         return "Counsellor";    
      } 
      case "10": { 
         return "Medical Practitioner"; 
      } 
      case "17": { 
        return "Psychology Student"; 
      }
      case "13": { 
        return "Psychiatric Nurse"; 
      }
      case "15": { 
        return "Social Worker"; 
      }
      case "18": { 
        return "Student"; 
      }
      case "19": { 
        return "Researcher"; 
      }
      case "16": { 
        return "Other"; 
      }
      default: { 
         break;              
      } 
   }
  }

}



// WEBPACK FOOTER //
// ./src/pages/email/email.ts